Vue.component('addMod', {
  template: templates.addMod,
  data() {
    return {
      model: {
        searchResults: []
      }
    }
  },
  methods: {
    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="mod-user"]').val();

      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data;
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
          }
          
          $('[name="mod-user"]').autocomplete({
            source: names
          });
        })
        .catch(function (error) {
        
        });
    },
    getUserId(twitchDisplayName, callback) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          callback(user.twitchId);
          return;
        }
      }

      twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {

        for (let data of userData) {
          callback(data.id);
          return;
        }
        
        callback(null);

      });
    },
    save() {
      const c = this;
      const twitchDisplayName = $('[name="mod-user"]').val();

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId) {
          utils.alert.error('User required!');
          return;
        }

        const data = {
          twitchId: twitchId,
        }

        userService.addMod(data)
          .then(function (response) {
            utils.alert.success('Saved!');
            c.reset();
          })
          .catch(function (error) {
            //console.log(error);
          });

      });
    },
    reset() {
      const c = this;
      $('[name="mod-user"]').val('');
    }
  }
});